"use client";

import * as React from "react";
import { Suspense } from "react";
import { MotionConfig } from "framer-motion";
import { ThemeProvider as NextThemesProvider } from "next-themes";

import { ConfirmProvider } from "@/components/ui/confirm-provider";

export function ThemeProvider({
  children,
  ...props
}: React.ComponentProps<typeof NextThemesProvider>) {
  // {...props} reicht u.a. das `nonce`-Prop von next-themes durch.
  // Layout setzt es aus dem x-nonce-Request-Header (siehe src/proxy.ts).
  // Ohne Nonce blockt CSP next-themes' Theme-Bootstrap-Inline-Script und
  // der Dark-Mode flickert beim ersten Paint.
  //
  // MotionConfig reducedMotion="user": Framer Motion respektiert
  // `prefers-reduced-motion: reduce` automatisch — Transforms, Pulses und
  // Scroll-Reveals werden auf duration: 0 gesetzt. WCAG 2.1 SC 2.3.3.
  // Custom RAF-Loops (CountUp) müssen den Hook useReducedMotion() selbst
  // konsumieren — das machen wir lokal in der CountUp-Komponente.
  //
  // Wartungsmodus läuft jetzt server-seitig im Proxy
  // (siehe src/lib/maintenance/server-check.ts) — kein Client-Guard mehr nötig.
  return (
    <MotionConfig reducedMotion="user">
      <NextThemesProvider {...props}>
        {/* Suspense needed because NextThemesProvider injects a <script> tag
            that triggers a harmless console warning without it. */}
        <Suspense>
          <ConfirmProvider>{children}</ConfirmProvider>
        </Suspense>
      </NextThemesProvider>
    </MotionConfig>
  );
}
